export default class HighlightRule {
    public static None: number = 0;
    public static AwayTeam: number = 1;
    public static HomeTeam: number = 2;
    public static Both: number = 3;
    public static Calculate: number = 4;

    static CalculateHighlightOption(highlightRule, homeTeam, awayTeam) {
        let highlightAwayTeam = false;
        let highlightHomeTeam = false;

        switch (highlightRule) {
            case HighlightRule.AwayTeam:
                highlightAwayTeam = true;
                break;
            case HighlightRule.HomeTeam:
                highlightHomeTeam = true;
                break;
            case HighlightRule.Both:
                highlightAwayTeam = true;
                highlightHomeTeam = true;
                break;
            case HighlightRule.Calculate:
                let homeTeamValue = homeTeam.percentageValue;
                if (!homeTeamValue)
                    homeTeamValue = parseInt(homeTeam.displayValue);

                if (homeTeamValue !== 0 && !homeTeamValue)
                    throw new Error("Failed to parse values for home team");

                let awayTeamValue = awayTeam.percentageValue;
                if (!awayTeamValue)
                    awayTeamValue = parseInt((awayTeam.displayValue));

                if (awayTeamValue !== 0 && !awayTeamValue)
                    throw new Error("Failed to parse values for away team");

                if (homeTeamValue == awayTeamValue) {
                    highlightHomeTeam = false;
                    highlightAwayTeam = false;
                } else {
                    highlightHomeTeam = homeTeamValue > awayTeamValue;
                    highlightAwayTeam = !highlightHomeTeam;
                }
                break;
            case HighlightRule.None:
            default:
                highlightHomeTeam = false;
                highlightAwayTeam = false;
                break;
        }

        return {
            homeTeam: highlightHomeTeam,
            awayTeam: highlightAwayTeam
        };
    }
}